<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Empanelment Report</h5>
  </div>
  <div class="container" id="mainContent">
    <div class="modal-body">
      <div class="row mt-2">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch</label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel"
                  (selectionChange)="onBranchSelect()">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Service Vertical</label>

            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedServiceVertical" #servicevertical="ngModel">
                  <mat-option (click)="
                  selectAllServiceVertical(servicevertical, serviceVerticalList)
                " [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let vertical of serviceVerticalList" [value]="vertical">
                    {{ vertical.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>



      <div class="row mt-2">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Roles</label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedEmpanelmentRole" #empanelmentRole="ngModel"
                  (selectionChange)="onRoleSelect()">
                  <mat-option (click)="
                  selectAllEmpanelmentRole(empanelmentRole, empanelmentRoleList)
                " [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let role of empanelmentRoleList" [value]="role">
                    {{ role.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-4">
              <label> Date </label>
            </div>

            <div class="col-sm-6">
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="fromDate" ngbDatepicker
                  #fromDate="ngbDatepicker" [placement]="'bottom'" [(ngModel)]="selectedCurrentDate" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme calendar" (click)="fromDate.toggle()" type="button"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-6">
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-4">
              <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
                View Report
              </button>
            </div>
            <div class="col-sm-4" *ngIf="showExportToExcelButton">
              <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
                <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
              </button>
            </div>
            <div class="col-sm-4" *ngIf="showExportToExcelButton">
              <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
                <i class="fa fa-file-pdf-o mr-2"></i>Export As PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" id="mainContent" *ngIf="empanelmentReportList.length>0">
      <div class="row pt-3 justify-content-center text-center">
        <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div *ngFor="let list of empanelmentReportList">
        <div class="mt-3" *ngIf="list.role == 'Article'">
          <div class="row col-md-12">
            <span class="bg-theme-title" *ngIf="list.role == 'Article'"> Article</span>
            <table class="table table-bordered table-sm" style="display: block; overflow-x: auto; white-space: nowrap">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Article Name</th>
                  <th>Gender</th>
                  <th>Firm Joining Date</th>
                  <th>DOB</th>
                  <th>Reporting Partner</th>
                  <th>Contact No.</th>
                  <th>Email Id</th>
                  <th>Branch Name</th>
                  <th>ICAI Registration No.</th>
                  <th>Type Of Article</th>
                  <th>Registered Partner</th>
                  <th>Articleship End Date</th>
                  <th>Service Vertical</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let roles of list.details; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    {{ roles.firstName }} {{ roles.middleName }}
                    {{ roles.lastName }}
                  </td>
                  <td>{{ roles.gender }}</td>
                  <td>{{ roles.joiningDate | date: "dd-MM-yyyy" }}</td>
                  <td>{{ roles.dateOfBirth | date: "dd-MM-yyyy" }}</td>
                  <td>
                    {{ roles.reportingPFName }} {{ roles.reportingPMName }}
                    {{ roles.reportingPLName }}
                  </td>
                  <td>{{ roles.officalMobileNumber }}</td>
                  <td>{{ roles.email }}</td>
                  <td>{{ roles.branch }}</td>
                  <td>{{ roles.icaiRegistrationNumber }}</td>
                  <td>{{ roles.articleType }}</td>

                  <td>
                    {{ roles.regPartnerFName }} {{ roles.regPartnerMName }}
                    {{ roles.regPartnerLName }}
                  </td>
                  <td>{{ roles.articleshipEndDate | date: "dd-MM-yyyy" }}</td>
                  <td>{{ roles.serviceVertical }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-3" *ngIf="list.role == 'Senior Manager' || list.role == 'Manager' || list.role == 'Partner'||
      list.role == 'Principal'||list.role == 'Director'||list.role == 'Consultant'|| list.role=='Associate'
      || list.role=='Managing Partner' || list.role=='Designated Partner'">
          <div class="row col-md-12">
            <span class="bg-theme-title" *ngIf="list.role == 'Senior Manager'">Senior Manager</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Manager'">Manager</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Partner'">Partner</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Principal'">Principal</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Director'">Director</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Consultant'">Consultant</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Associate'">Associate</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Managing Partner'">Managing Partner</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Designated Partner'">Designated Partner</span>

            <table class="table table-bordered table-sm" style="display: block; overflow-x: auto; white-space: nowrap">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Employee Name</th>
                  <th>Gender</th>
                  <th>Firm Joining Date</th>
                  <th>DOB</th>
                  <th>Reporting Partner</th>
                  <th>Contact No.</th>
                  <th>Email Id</th>
                  <th>Branch Name</th>
                  <th>Date Of Membership No.</th>
                  <th>Membership No.</th>
                  <th>No. of Years of Experience</th>
                  <th>Certification</th>
                  <th>Role</th>
                  <th>Designation</th>
                  <th>Service Vertical</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let roles of list.details; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    {{ roles.firstName }} {{ roles.middleName }}
                    {{ roles.lastName }}
                  </td>
                  <td>{{ roles.gender }}</td>
                  <td>{{ roles.joiningDate | date: "dd-MM-yyyy" }}</td>
                  <td>{{ roles.dateOfBirth | date: "dd-MM-yyyy" }}</td>
                  <td>
                    {{ roles.reportingPFName }} {{ roles.reportingPMName }}
                    {{ roles.reportingPLName }}
                  </td>
                  <td>{{ roles.officalMobileNumber }}</td>
                  <td>{{ roles.email }}</td>
                  <td>{{ roles.branch }}</td>
                  <td>{{ roles.dateOfMembershipNumber | date: "dd-MM-yyyy" }}</td>
                  <td>{{ roles.membershipNumber }}</td>

                  <td>{{ roles.experience }}</td>
                  <td>{{ roles.certifications }}</td>
                  <td>{{ roles.role }}</td>
                  <td>{{ roles.designation }}</td>
                  <td>{{ roles.serviceVertical }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-3"
          *ngIf="list.role == 'Assistant'|| list.role == 'Account Executive' || list.role == 'HR Assistant' || 
      list.role == 'HR Executive'|| list.role == 'HR Manager'|| list.role == 'Salaried Partner'|| list.role == 'Office Assistant'">
          <div class="row col-md-12">
            <span class="bg-theme-title" *ngIf="list.role == 'Assistant'">Assistant</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Account Executive'">Account Executive</span>
            <span class="bg-theme-title" *ngIf="list.role == 'HR Assistant'">HR Assistant</span>
            <span class="bg-theme-title" *ngIf="list.role == 'HR Executive'">HR Executive</span>
            <span class="bg-theme-title" *ngIf="list.role == 'HR Manager'">HR Manager</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Salaried Partner'">Salaried Partner</span>
            <span class="bg-theme-title" *ngIf="list.role == 'Office Assistant'">Office Assistant</span>

            <table class="table table-bordered table-sm" style="display: block; overflow-x: auto; white-space: nowrap">
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Employee Name</th>
                  <th>Gender</th>
                  <th>Firm Joining Date</th>
                  <th>DOB</th>
                  <th>Reporting Partner</th>
                  <th>Contact No.</th>
                  <th>Email Id</th>
                  <th>Branch Name</th>
                  <th>No. of Years of Experience</th>
                  <th>Role</th>
                  <th>Designation</th>
                  <th>Service Vertical</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let roles of list.details; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    {{ roles.firstName }} {{ roles.middleName }}
                    {{ roles.lastName }}
                  </td>
                  <td>{{ roles.gender }}</td>
                  <td>{{ roles.joiningDate | date: "dd-MM-yyyy" }}</td>
                  <td>{{ roles.dateOfBirth | date: "dd-MM-yyyy" }}</td>
                  <td>
                    {{ roles.reportingPFName }} {{ roles.reportingPMName }}
                    {{ roles.reportingPLName }}
                  </td>
                  <td>{{ roles.officalMobileNumber }}</td>
                  <td>{{ roles.email }}</td>
                  <td>{{ roles.branch }}</td>
                  <td>{{ roles.experience }}</td>
                  <td>{{ roles.role }}</td>
                  <td>{{ roles.designation }}</td>
                  <td>{{ roles.serviceVertical }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>